export const DEFAULTS = {
  config: { linkTypes: { anchor: true } },
};
